module.exports = __webpack_public_path__ + "static/media/3m.fd82cba3.png";